import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-smart-booking-bar',
  templateUrl: './smart-booking-bar.component.html',
  styleUrls: ['./smart-booking-bar.component.scss']
})
export class SmartBookingBarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
